export enum contactCreditEnum {
    LIVE_CHAT_LEADS = 'liveChatLeads',
    INBOUND_CALL_LEADS = 'inboundCallLeads',
    HOTKEYS = 'hotkeys',
    ALL = '',
}
